<template>
  <div class="d2-plan-card-item" :class="{ 'current': plansListOData.plan_o_text == '使用中' || plansListOData.plan_o_text == 'Using' }">
    <div class="d2-plan-card-name" style="color: var(--amber);">{{ plansListOData.plan_o_title }}</div>
    <div class="d2-plan-card-price-row"><span class="d2-plan-card-price">{{ plansListOData.plan_o_label_amount }}</span><span class="d2-plan-card-unit" v-if="plansListOData.is_amount">/{{lang['components']['Plan']['PlanC']['time_unit']}}</span></div>
    <ul class="d2-plan-card-features">
      <li v-for="(item, index) in description">
          <i class="fas fa-check"></i> <span v-html="item"></span>
      </li>
    </ul>
    <button v-if="plansListOData.plan_o_show" class="d2-plan-card-btn upgrade" @click="handleChickPlan(plansListOData.plan_id, 'O', '', 'fb')">
      {{ plansListOData.plan_o_text }}
    </button>
    <button v-else-if="!plansListOData.planHaveBind" class="d2-plan-card-btn upgrade" @click="handleChickPlan(plansListOData.plan_id, 'O', '', 'fb')">
      {{lang['components']['Plan']['PlanC']['pay_use']}}
    </button>
    <button
      v-else
      class="d2-plan-card-btn payagain"
      v-if="isExpiredData && (plansListOData.plan_o_text == '使用中' || plansListOData.plan_o_text == 'Using')"
      @click="handleChickPlan(plansListOData.plan_id, 'O', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanC']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanO',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListO:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListOData: {
      get: function () {
        return this.plansListO
      },
      set: function (value) {
        this.$emit('update:plansListOData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListO.plan_o_description
    },
    isDisabled: function() {
       return this.plansListO.plan_o_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-O {
    &:hover {
      border: 2px #E8C177 solid;
    }
  }
</style>